import styled from '@emotion/styled';
import { Icon, IconButton, tokens } from '@hotjar/hotsauce';
import { css } from '@emotion/react';
import { useTranslation } from '@hotjar/translations';
import { SessionNotRecordedPopover } from './SessionNotRecordedPopover';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const cursorBlock = require('@hotjar/shared-assets/icons/cursor-block.ico');

interface RecordingIconLinkProps {
  trackClick: () => void;
  trackHover: () => void;
  href?: string;
  outlinedIcon?: boolean;
}

const DisabledIcon = styled.div`
  width: ${tokens.spacer.x4};
  text-align: center;

  &:hover {
    cursor: url(${cursorBlock}), default !important;
  }
`;

const StyledIcon = styled(Icon)<{ outlined: boolean }>`
  ${({ outlined }) =>
    outlined &&
    css`
      color: ${tokens.color.secondary_cta};
    `}
`;

export function RecordingIconLink({
  trackClick,
  trackHover,
  href,
  outlinedIcon = false,
}: RecordingIconLinkProps): JSX.Element {
  const { t } = useTranslation('feedback', { keyPrefix: 'surveys.responses-list.recording' });

  return href !== undefined ? (
    <IconButton
      size="s"
      kind="ghost"
      description={t('play-recording')}
      tooltipText={t('play-recording')}
      icon={<StyledIcon icon="play" outlined={outlinedIcon} />}
      isExternal
      as="a"
      onClick={trackClick}
      href={href}
    />
  ) : (
    <DisabledIcon onClick={(e) => e.stopPropagation()}>
      <SessionNotRecordedPopover onShow={trackHover}>
        <Icon
          css={{ margin: '6px' }} // this margin is used to avoid the SessionNotRecordedPopover disapear when the user's mouse is between the button and the Popover
          icon={outlinedIcon ? 'play' : 'play_alt'}
          color="text_disabled"
          description={t('session-not-recorded')}
        />
      </SessionNotRecordedPopover>
    </DisabledIcon>
  );
}
